export function isPositive(value: number) {
  return Math.sign(value) === 1;
}
